import React, {ReactElement} from 'react';

import {ExpertIcon} from '../../../resources/Icons';
import Col from '../../common/Col';
import Row from '../../common/Row';
import {PayButton} from './buttons/PillButtons';

type PayExpertProps = {
  disabled?: boolean;
  cost: number;
  onPayClick: () => void;
};

const PayExpertCard = (props: PayExpertProps): ReactElement => {
  const {disabled = false, cost, onPayClick} = props;

  return (
    <div
      className={
        'relative flex flex-row w-[37rem] mobile:w-auto h-auto mobile:h-[20rem] border-2 border-gray-100 font-sans rounded-2xl py-md px-sm text-center items-center mobile:items-start '
      }
    >
      <ExpertIcon className={'w-[10rem] h-[10rem]'} />
      <Col className="ml-10 items-center text-xl font-medium mobile:text-lg">
        <Row>Pay for an</Row>
        <Row>expert</Row>
      </Col>
      <PayButton
        className={'absolute my-auto -right-48 mobile:right-1/2 mobile:translate-x-1/2 mobile:-bottom-20'}
        disabled={disabled}
        cost={cost}
        purchased={false}
        onClick={onPayClick}
      />
    </div>
  );
};

export default PayExpertCard;
